'use client';

import React__default from 'react';

var CopyIcon = function () {
    return (React__default.createElement("svg", { width: '24', height: '24', viewBox: '0 0 24 24', fill: 'none', xmlns: 'http://www.w3.org/2000/svg' },
        React__default.createElement("path", { d: 'M8.6 2C7.716 2 7 2.716 7 3.6V16.4C7 17.284 7.716 18 8.6 18H19C19.884 18 20.6 17.284 20.6 16.4V7.2C20.6 6.988 20.516 6.78477 20.3656 6.63438L15.9656 2.23438C15.8152 2.08397 15.612 2 15.4 2H8.6ZM15 3.52344L19.0766 7.6H15.8C15.3584 7.6 15 7.2416 15 6.8V3.52344ZM4.6 6C3.716 6 3 6.716 3 7.6V20.4C3 21.284 3.716 22 4.6 22H15C15.884 22 16.6 21.284 16.6 20.4V19.6H8.6C6.8352 19.6 5.4 18.1648 5.4 16.4V6H4.6Z', fill: '#888' })));
};
var CopyIcon$1 = React__default.memo(CopyIcon);

export { CopyIcon$1 as default };
//# sourceMappingURL=index.js.map
